import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

export class MainVersionsTop extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  componentDidUpdate(prevProps) { }

  render() {
    const { intl, isShowCompareVersion, opviews } = this.props

    return (
      <div className="bb-history__top">
        <h3>
          {' '}
          {isShowCompareVersion
            ? intl.formatMessage({
              id: 'compare_versions',
            })
            : intl.formatMessage({
              id: 'versions',
            })}{' '}
        </h3>
        <div className="bb-history__top-actions comparar">
          {/*.active*/}
          <span
            className={!isShowCompareVersion ? 'comparar active' : 'comparar'}
            onClick={() =>
              this.props.showOrHideViews(opviews.get('COMPARE_VERSIONS'))
            }
            style={{ cursor: 'pointer' }}
          >
            <svg
              width={20}
              height={24}
              viewBox="0 0 20 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.3846 5.07692V18.9231C19.3846 19.6575 19.0929 20.3619 18.5735 20.8812C18.0542 21.4006 17.3498 21.6923 16.6154 21.6923H13.3846C13.1398 21.6923 12.905 21.5951 12.7319 21.4219C12.5588 21.2488 12.4615 21.014 12.4615 20.7692C12.4615 20.5244 12.5588 20.2896 12.7319 20.1165C12.905 19.9434 13.1398 19.8462 13.3846 19.8462H16.6154C16.8602 19.8462 17.095 19.7489 17.2681 19.5758C17.4412 19.4027 17.5385 19.1679 17.5385 18.9231V5.07692C17.5385 4.83211 17.4412 4.59732 17.2681 4.42421C17.095 4.2511 16.8602 4.15385 16.6154 4.15385H13.3846C13.1398 4.15385 12.905 4.05659 12.7319 3.88348C12.5588 3.71037 12.4615 3.47558 12.4615 3.23077C12.4615 2.98595 12.5588 2.75117 12.7319 2.57806C12.905 2.40494 13.1398 2.30769 13.3846 2.30769H16.6154C17.3498 2.30769 18.0542 2.59945 18.5735 3.11878C19.0929 3.63811 19.3846 4.34248 19.3846 5.07692ZM10.6154 0.923077V23.0769C10.6154 23.3217 10.5181 23.5565 10.345 23.7296C10.1719 23.9027 9.93712 24 9.69231 24C9.44749 24 9.2127 23.9027 9.03959 23.7296C8.86648 23.5565 8.76923 23.3217 8.76923 23.0769V21.6923H2.76923C2.03479 21.6923 1.33042 21.4006 0.811089 20.8812C0.291757 20.3619 0 19.6575 0 18.9231V5.07692C0 4.34248 0.291757 3.63811 0.811089 3.11878C1.33042 2.59945 2.03479 2.30769 2.76923 2.30769H8.76923V0.923077C8.76923 0.678262 8.86648 0.443473 9.03959 0.270363C9.2127 0.0972524 9.44749 0 9.69231 0C9.93712 0 10.1719 0.0972524 10.345 0.270363C10.5181 0.443473 10.6154 0.678262 10.6154 0.923077ZM8.76923 19.8462V4.15385H2.76923C2.52442 4.15385 2.28963 4.2511 2.11652 4.42421C1.94341 4.59732 1.84615 4.83211 1.84615 5.07692V18.9231C1.84615 19.1679 1.94341 19.4027 2.11652 19.5758C2.28963 19.7489 2.52442 19.8462 2.76923 19.8462H8.76923Z"
                fill="#0096D6"
              />
            </svg>
            <p>
              {intl.formatMessage({
                id: 'compare',
              })}{' '}
            </p>
          </span>
          {/*.active*/}
          <span
            className={isShowCompareVersion ? 'aplicar active' : 'aplicar'}
            style={{ cursor: 'pointer' }}
            onClick={() => this.props.showModalCompareVersion(true)}
          >
            <svg
              width={19}
              height={15}
              viewBox="0 0 19 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.7297 0.316664C17.6416 0.216324 17.5368 0.136682 17.4213 0.0823323C17.3059 0.0279823 17.1821 0 17.057 0C16.9319 0 16.8081 0.0279823 16.6927 0.0823323C16.5772 0.136682 16.4724 0.216324 16.3843 0.316664L5.68825 12.4138L1.62392 7.81046C1.44552 7.60887 1.20357 7.49562 0.951272 7.49562C0.698979 7.49562 0.457019 7.60887 0.278621 7.81046C0.100223 8.01204 3.75946e-09 8.28545 0 8.57054C-3.75946e-09 8.85563 0.100223 9.12904 0.278621 9.33063L5.0156 14.6833C5.10367 14.7837 5.20846 14.8633 5.3239 14.9177C5.43935 14.972 5.56318 15 5.68825 15C5.81332 15 5.93715 14.972 6.0526 14.9177C6.16805 14.8633 6.27283 14.7837 6.3609 14.6833L17.7297 1.83683C17.8184 1.73731 17.8889 1.61891 17.937 1.48845C17.9851 1.358 18.0099 1.21807 18.0099 1.07675C18.0099 0.935425 17.9851 0.795499 17.937 0.665044C17.8889 0.534588 17.8184 0.416185 17.7297 0.316664Z"
                fill="#0096D6"
              />
            </svg>
            <p>
              {intl.formatMessage({
                id: 'apply',
              })}
            </p>
          </span>
          {isShowCompareVersion && (
            <span
              onClick={() =>
                this.props.showOrHideViews(opviews.get('VERSIONS'))
              }
              style={{ cursor: 'pointer' }}
            >
              <p>
                {intl.formatMessage({
                  id: 'cancel_button',
                })}{' '}
              </p>
            </span>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const obj = {}

  return obj
}

const mapDispatchToProps = {}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MainVersionsTop))
)
